import { useTranslation } from 'react-i18next';
import { StyledTitle } from 'components/StyledTitle';
import { GreetingBox } from './styledComponent';
import { useProfileInfoContext } from '../../../contexts/profileInfo';

export const WelcomeMessage = (): JSX.Element => {
  const { t } = useTranslation();
  const { state: data } = useProfileInfoContext();

  return (
    <GreetingBox isReminder={false}>
      <StyledTitle color="var(--white)" level={5}>
        {t('home.hello', { memberName: [data?.lastName, data?.firstName].filter((name) => !!name).join(' ') })}
      </StyledTitle>
      <StyledTitle color="var(--white)" level={4}>
        {t('home.howCanWeHelp')}
      </StyledTitle>
    </GreetingBox>
  );
};
